import {
  createRouter,
  createWebHistory,
  Router,
  RouteRecordRaw,
} from "vue-router";
import { RouteNames, RoutePaths } from "@/router/routes";

export const routes: RouteRecordRaw[] = [
  // {
  //   path: RoutePaths.LoginLayout,
  //   name: RouteNames.LOGIN_LAYOUT,
  //   component: LoginLayout,
  //   children: [
  //     {
  //       path: RoutePaths.LoginView,
  //       name: RouteNames.LOGIN_VIEW,
  //       component: () => import("@/views/LoginPage.vue"),
  //     },
  //   ],
  // },
  {
    path: RoutePaths.MainLayout,
    name: RouteNames.MAIN_LAYOUT,
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        redirect: {
          name: localStorage.supportAccessToken
            ? RouteNames.AUTH_PAGE
            : RouteNames.SUPPORT_MAIN_PAGE,
        },
      },
      {
        path: RoutePaths.SupportMainPage,
        name: RouteNames.SUPPORT_MAIN_PAGE,
        component: () => import("@/views/SupportMainPage.vue"),
        children: [
          {
            path: ":id",
            name: RouteNames.CURRENT_TICKET,
            component: () => import("@/views/SupportMainPage.vue"),
            props: true,
          },
        ],
      },
    ],
  },
  {
    path: RoutePaths.NotFound,
    name: RouteNames.NOT_FOUND,
    component: () => import("@/views/NotFoundPage.vue"),
  },
  {
    path: RoutePaths.AuthPage,
    name: RouteNames.AUTH_PAGE,
    component: () => import("@/views/SupportAuthView.vue"),
  },
];

const router: Router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
});

router.beforeEach((to) => {
  // const mainStore = useMainStore(); //pinia указывается тут

  // if (!mainStore.isAuthorized && to.name !== "Authorization") {
  //   return { name: "Authorization" };
  // }

  // @ts-ignore
  document.title = to.meta.title ?? window.document.title;
});

export default router;
